export default __webpack_public_path__ + "static/media/mypage_pc@2x.eafdc6a7.jpg";